// フォームの初期値が許容された型
export type ConfirmationInputsForForm = {
  agreement: boolean;
};

export const initialConfirmationInputsForForm: ConfirmationInputsForForm = {
  agreement: false,
};
